import {
  forgotPasswordAPI,
  loginAPI,
  sendUnAuthOTPAPI,
  validateOTPAPI,
  validateUnAuthOTPAPI,
} from '../adapter/adapter'
import { LOGIN_CONST } from '../common/constant/page-constant'
import { setCookieCustom } from '../common/utils/storageUtils'

export function loginHelper(data) {
  let reqData = {
    email: data.email,
    password: data.password,
  }

  let promise = new Promise(function (resolve, reject) {
    loginAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          let accessToken = res.data.data.access_token
          let refreshToken = res.data.data.refresh_token

          if (accessToken && refreshToken) {
            setCookieCustom(LOGIN_CONST.ACCESS_TOKEN, accessToken)
            setCookieCustom(LOGIN_CONST.REFRESH_TOKEN, refreshToken)
          }
          resolve(res.data.data)
        } else {
          reject('Login Failure')
        }
      })
      .catch((err) => {
        reject('Login Failure')
      })
  })

  return promise
}

export function sendUnAuthOTPHelper(mobileNumber) {
  let reqData = {
    mobile_no: mobileNumber,
  }

  let promise = new Promise(function (resolve, reject) {
    sendUnAuthOTPAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else {
          resolve()
        }
      })
      .catch((err) => {
        reject('Login Failure')
      })
  })

  return promise
}

export function validateOTPHelper(otp) {
  let reqData = { otp }

  let promise = new Promise(function (resolve, reject) {
    validateOTPAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Login Failure')
        }
      })
      .catch((err) => {
        reject('Login Failure')
      })
  })

  return promise
}

export function validateUnAuthOTPHelper(mobileNumber, otp) {
  let reqData = { mobile_no: mobileNumber, otp: otp }

  let promise = new Promise(function (resolve, reject) {
    validateUnAuthOTPAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Login Failure')
        }
      })
      .catch((err) => {
        reject('Login Failure')
      })
  })

  return promise
}

export function forgotPasswordHelper(txnId, mobileNumber, password) {
  let reqData = {
    mobile_no: mobileNumber,
    txn_id: txnId,
    password: password,
  }

  let promise = new Promise(function (resolve, reject) {
    forgotPasswordAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Login Failure')
        }
      })
      .catch((err) => {
        reject('Login Failure')
      })
  })

  return promise
}
